import type { RouteRecordRaw } from 'vue-router'
import { EPage } from '@/shared/enum/page.enum'
import { ROUTES_GUARDS } from '@/router/mce/guards'

export const routesMce: RouteRecordRaw[] = [
  {
    path: '/maintenance',
    component: () => import('@/maintenance/pages/MaintenancePage.vue'),
    name: EPage.MAINTENANCE
  },
  {
    path: '/',
    name: EPage.ROOT,
    redirect: { name: EPage.BLANK },
    component: () => import('@/components/layouts/MceLayout.vue'),
    children: [
      {
        path: '',
        name: EPage.BLANK,
        component: () => import('@/blank/BlankPage.vue'),
        beforeEnter: ROUTES_GUARDS[EPage.BLANK]
      },
      {
        path: 'landing',
        name: EPage.LANDING,
        beforeEnter: ROUTES_GUARDS[EPage.LANDING],
        component: () => import('@/landing/pages/LandingPage.vue')
      },
      {
        path: 'turnOn3G',
        name: EPage.TURN_ON_3G,
        beforeEnter: ROUTES_GUARDS[EPage.TURN_ON_3G],
        component: () => import('@/turn-on-3g/pages/TurnOn3gPage.vue')
      },
      {
        path: 'packages',
        name: EPage.PACKAGES,
        beforeEnter: ROUTES_GUARDS[EPage.PACKAGES],
        component: () => import('@/packages/pages/PackagesPage.vue')
      },
      {
        path: 'microcredits',
        name: EPage.MICROCREDITS,
        beforeEnter: ROUTES_GUARDS[EPage.MICROCREDITS],
        component: () => import('@/microcredits/pages/MicrocreditsPage.vue')
      },
      {
        path: 'invoice',
        name: EPage.INVOICE,
        beforeEnter: ROUTES_GUARDS[EPage.INVOICE],
        component: () => import('@/invoice/pages/InvoicePage.vue')
      },
      {
        path: 'profile',
        name: EPage.PROFILE,
        beforeEnter: ROUTES_GUARDS[EPage.PROFILE],
        component: () => import('@/profile/pages/ProfilePage.vue')
      },
      {
        path: 'genericError',
        name: EPage.GENERIC_ERROR,
        beforeEnter: ROUTES_GUARDS[EPage.GENERIC_ERROR],
        component: () => import('@/generic-error/pages/GenericErrorPage.vue')
      },
      {
        path: 'generateFolio',
        name: EPage.GENERATE_FOLIO,
        beforeEnter: ROUTES_GUARDS[EPage.GENERATE_FOLIO],
        component: () => import('@/generate-folio/GenerateFolio.vue')
      },
      {
        path: 'maintenance',
        name: EPage.MAINTENANCE,
        beforeEnter: ROUTES_GUARDS[EPage.MAINTENANCE],
        component: () => import('@/maintenance/pages/MaintenancePage.vue')
      },
      {
        path: 'result/:folio',
        name: EPage.RESULT,
        beforeEnter: ROUTES_GUARDS[EPage.RESULT],
        component: () => import('@/result/pages/ResultPage.vue')
      },
      {
        path: 'promotions/:promotion',
        name: EPage.PROMOTIONS,
        beforeEnter: ROUTES_GUARDS[EPage.PROMOTIONS],
        component: () => import('@/promotions/pages/PromotionsPage.vue')
      },
      {
        path: 'payForm/:paymentForm/:folio',
        name: EPage.PAYMENT_FORM,
        beforeEnter: ROUTES_GUARDS[EPage.PAYMENT_FORM],
        component: () => import('@/payment-form/page/PaymentFormPage.vue')
      },
      {
        path: 'history',
        name: EPage.HISTORY,
        beforeEnter: ROUTES_GUARDS[EPage.HISTORY],
        component: () => import('@/history/pages/HistoryPage.vue')
      },
      {
        path: 'sendRecharges',
        name: EPage.SEND_RECHARGES,
        beforeEnter: ROUTES_GUARDS[EPage.SEND_RECHARGES],
        component: () => import('@/send-recharges/pages/SendRechargesPage.vue')
      },
      {
        path: 'shortLink',
        name: EPage.SHORT_LINK,
        beforeEnter: ROUTES_GUARDS[EPage.SHORT_LINK],
        component: () => import('@/short-link/pages/ShortLinkPage.vue')
      },
      {
        path: 'buyRecharges',
        name: EPage.BUY_RECHARGES,
        beforeEnter: ROUTES_GUARDS[EPage.BUY_RECHARGES],
        component: () => import('@/buy-recharges/pages/BuyRechargesPage.vue')
      },
      {
        path: 'terms',
        name: EPage.TERMS,
        beforeEnter: ROUTES_GUARDS[EPage.TERMS],
        component: () => import('@/terms/pages/TermsPage.vue')
      },
      {
        path: 'latePayment',
        name: EPage.LATE_PAYMENT,
        beforeEnter: ROUTES_GUARDS[EPage.LATE_PAYMENT],
        component: () => import('@/late-payment/pages/LatePaymentPage.vue')
      },
      {
        path: 'internetOnDemand',
        name: EPage.INTERNET_ON_DEMAND,
        beforeEnter: ROUTES_GUARDS[EPage.INTERNET_ON_DEMAND],
        component: () => import('@/internet-on-demand/pages/InternetOnDemandPage.vue')
      },
      {
        path: ':pathMatch(.*)*',
        name: EPage.NOT_FOUND,
        component: () => import('@/not-found/pages/NotFoundPage.vue')
      }
    ]
  }
]
